export const getLastDayFromPersonalPickupString = (days: string | null): { days: string | null; daysCount: number } => {
    const daysCount = parseInt(days !== null ? (days.includes('-') ? days.split('-')[1] : days) : '0');

    return {
        days,
        daysCount,
    };
};
